import React, { useState, useEffect } from "react"
import MetaTags from "react-meta-tags"
import { Link, useLocation, useHistory } from "react-router-dom"
import {
  Col,
  Container,
  Form,
  FormGroup,
  Input,
  InputGroup,
  InputGroupAddon,
  Label,
  Row,
  Card,
  CardImg,
  CardTitle,
  Modal,
  Collapse,
} from "reactstrap"
import { Carousel } from "react-responsive-carousel"
import "react-responsive-carousel/lib/styles/carousel.min.css"
import * as url from "helpers/url_helper"
import SweetAlert from "react-bootstrap-sweetalert"

//i18n
import PropTypes from "prop-types"
import { withTranslation } from "react-i18next"

// import images
import logodark from "../../assets/images/logo-dark.png"
import logolight from "../../assets/images/logo-light.png"
import bgImage from "assets/images/ugifts/loginbg.png"
import bgProfile from "assets/images/ugifts/profile_bg.png"
import iconCurrent from "assets/images/ugifts/icons/checkout/icon_step_current.png"
import iconDone from "assets/images/ugifts/icons/checkout/icon_step_done.png"
import iconIncomplete from "assets/images/ugifts/icons/checkout/icon_step_incomplete.png"
import iconEditable from "assets/images/ugifts/icons/icon_editable.png"

import { Button } from "@material-ui/core"

function useQuery() {
  return new URLSearchParams(useLocation().search)
}

const CheckoutConfirmation = props => {
  const query = useQuery()
  const history = useHistory()

  const [token, setToken] = useState(null)
  const [uid, setUid] = useState(null)
  const [quantity, setQuantity] = useState(0)
  const [country, setCountry] = useState("")

  useEffect(() => {
    if (localStorage.getItem("authAPI")) {
      const obj = JSON.parse(localStorage.getItem("authAPI"))
      console.log(
        "storage",
        obj.api_token_expiry + " / " + Math.floor(Date.now() / 1000)
      )
      if (obj.api_token_expiry < Math.floor(Date.now() / 1000)) {
        getToken()
      } else {
        setToken(obj)
      }
    } else {
      getToken()
    }

    if (localStorage.getItem("authUser")) {
      const obj = JSON.parse(localStorage.getItem("authUser"))
      setUid(obj.member_id)
      console.log(obj)
    }

    if (localStorage.getItem("country")) {
      setCountry(localStorage.getItem("country"))
    }

    if (localStorage.getItem("I18N_LANGUAGE")) {
      setLanguage(localStorage.getItem("I18N_LANGUAGE"))
    }
  }, [])

  const getToken = async () => {
    var urlencoded = new URLSearchParams()
    urlencoded.append("option", "get_api_token")
    urlencoded.append("source", "web")
    urlencoded.append("api_key", process.env.REACT_APP_APIKEY)

    const requestOptions = {
      method: "POST",
      body: urlencoded,
    }

    console.log("Request token", urlencoded.toString())

    const response = await fetch(url.UGIFT_STAGING_POST_AUTH, requestOptions)
    const postresponse = await response.json()

    console.log(response.status, postresponse.message)

    if (response.status == 200 && postresponse.success) {
      setToken(postresponse)
      localStorage.setItem("authAPI", JSON.stringify(postresponse))
      console.log(response.status, token)
    } else {
      // seterror_alert(true)
    }
  }

  useEffect(() => {
    if (token && country) {
      getUserProfile()
      getBasketData()
      getGiftCategoryList()
      console.log("use effect")
    }
  }, [token, country])

  const [userData, setUserData] = useState(null)
  const getUserProfile = async () => {
    var urlencoded = new URLSearchParams()
    urlencoded.append("option", "detail_profile")
    urlencoded.append("member_id", uid)

    const requestOptions = {
      method: "POST",
      // mode: "no-cors",
      headers: {
        // "Content-Type": "application/json",
        Authorization: "Bearer " + token.api_token,
      },
      body: urlencoded,
    }

    console.log("Request category", urlencoded.toString())

    const response = await fetch(
      url.UGIFT_STAGING_PROFILE,
      // "http://47.241.176.8/api/external/auth/",
      requestOptions
    )
    const postresponse = await response.json()
    // response.body
    // setPostResponse(postresponse)
    console.log(response.status, postresponse)

    if (response.status == 200) {
      // history.push("/tables-applicationtable")
      setUserData(postresponse.table)
    } else {
      // seterror_alert(true)
    }
  }

  const [basketData, setBasketData] = useState(null)
  const [giftcardId, setGiftcardId] = useState(null)
  const getBasketData = async () => {
    var urlencoded = new URLSearchParams()
    urlencoded.append("option", "detail_basket")
    urlencoded.append("member_id", uid)

    const requestOptions = {
      method: "POST",
      // mode: "no-cors",
      headers: {
        // "Content-Type": "application/json",
        Authorization: "Bearer " + token.api_token,
      },
      body: urlencoded,
    }

    console.log("Request basket", urlencoded.toString())

    const response = await fetch(
      url.UGIFT_STAGING_BASKET,
      // "http://47.241.176.8/api/external/auth/",
      requestOptions
    )
    const postresponse = await response.json()
    // response.body
    // setPostResponse(postresponse)
    console.log(response.status, postresponse)

    if (response.status == 200) {
      // history.push("/tables-applicationtable")
      setBasketData(postresponse.table)
      if (postresponse.table.giftcard_id) {
        setGiftcardId(postresponse.table.giftcard_id)
      }
    } else {
      // seterror_alert(true)
    }
  }

  useEffect(() => {
    if (token != null) getGiftList()
  }, [giftcardId])

  useEffect(() => {
    if (basketData) {
      var calculate = 0
      basketData.products.forEach(product => {
        calculate + parseInt(product.quantity)
      })
      setQuantity(calculate)
      localStorage.setItem("basketCount", calculate)
    }
  }, [basketData])

  const [giftData, setGiftData] = useState(null)
  const getGiftList = async () => {
    var urlencoded = new URLSearchParams()
    urlencoded.append("option", "detail_giftcard")
    // urlencoded.append("order_by", sortType)
    urlencoded.append("giftcard_id", giftcardId)

    const requestOptions = {
      method: "POST",
      headers: {
        Authorization: "Bearer " + token.api_token,
      },
      body: urlencoded,
    }

    console.log("Request giftcard product", urlencoded.toString())

    const response = await fetch(url.UGIFT_STAGING_GIFT, requestOptions)
    const postresponse = await response.json()
    // response.body
    // setPostResponse(postresponse)
    console.log(response.status, postresponse)

    if (response.status == 200) {
      // history.push("/tables-applicationtable")
      setGiftData(postresponse.table)
    } else {
      // seterror_alert(true)
    }
  }

  const [giftCategoryData, setGiftCategoryData] = useState(null)
  const getGiftCategoryList = async () => {
    var urlencoded = new URLSearchParams()
    urlencoded.append("option", "list_giftcard")
    urlencoded.append("order_by", "ASC")
    urlencoded.append("group_by_categories", true)
    urlencoded.append("filter_by_country_id", country)

    const requestOptions = {
      method: "POST",
      headers: {
        Authorization: "Bearer " + token.api_token,
      },
      body: urlencoded,
    }

    console.log("Request giftcard product", urlencoded.toString())

    const response = await fetch(url.UGIFT_STAGING_GIFT, requestOptions)
    const postresponse = await response.json()
    // response.body
    // setPostResponse(postresponse)
    console.log(response.status, postresponse)

    if (response.status == 200) {
      // history.push("/tables-applicationtable")
      setGiftCategoryData(postresponse.table)
    } else {
      // seterror_alert(true)
    }
  }

  const updateGiftCardId = async () => {
    var urlencoded = new URLSearchParams()
    urlencoded.append("option", "giftcard_to_basket")
    urlencoded.append("member_id", uid)
    urlencoded.append("giftcard_id", giftcardId)
    if (basketData.giftcard_id != giftcardId)
      urlencoded.append("giftcard_edit_parameter", giftData.edit_parameter)
    else
      urlencoded.append(
        "giftcard_edit_parameter",
        basketData.giftcard_edit_parameter
      )

    const requestOptions = {
      method: "POST",
      // mode: "no-cors",
      headers: {
        // "Content-Type": "application/json",
        Authorization: "Bearer " + token.api_token,
      },
      body: urlencoded,
    }

    console.log("Request basket", urlencoded.toString())

    const response = await fetch(
      url.UGIFT_STAGING_BASKET,
      // "http://47.241.176.8/api/external/auth/",
      requestOptions
    )
    const postresponse = await response.json()
    // response.body
    // setPostResponse(postresponse)
    console.log(response.status, postresponse)

    if (response.status == 200) {
      // history.push("/tables-applicationtable")
      // setBasketData(postresponse.table)
      history.push("/checkout-cardcustomization")
      // setsuccess_dlg(true)
      // setdynamic_title("Cart Updated")
      // setdynamic_description(postresponse.message)
    } else {
      seterror_alert(true)
      setdynamic_title(props.t("Cart Update Failed"))
      setdynamic_description(postresponse.message)
    }
  }

  const [success_dlg, setsuccess_dlg] = useState(false)
  const [success_dlg_noaction, setsuccess_dlg_noaction] = useState(false)
  const [error_alert, seterror_alert] = useState(false)
  const [dynamic_title, setdynamic_title] = useState("")
  const [dynamic_description, setdynamic_description] = useState("")

  const [language, setLanguage] = useState("eng")

  const multiLanguageHandler = data => {
    switch (language) {
      case "eng":
        return data.en
      case "cn":
        return data.cn ? data.cn : data.en
      case "jp":
        return data.jp ? data.jp : data.en
      default:
        return data.en
    }
  }

  return (
    <React.Fragment>
      <div>
        <MetaTags>
          <title>Ugift</title>
        </MetaTags>
        <Container fluid className="p-0">
          <Row className="g-0">
            {success_dlg_noaction ? (
              <SweetAlert
                success
                title={dynamic_title}
                onConfirm={() => {
                  setsuccess_dlg_noaction(false)
                }}
              >
                {dynamic_description}
              </SweetAlert>
            ) : null}
            {success_dlg ? (
              <SweetAlert
                success
                title={dynamic_title}
                onConfirm={() => {
                  history.push("/checkout-cardcustomization")
                }}
              >
                {dynamic_description}
              </SweetAlert>
            ) : null}
            {error_alert ? (
              <SweetAlert
                title={dynamic_title}
                danger
                onConfirm={() => {
                  seterror_alert(false)
                }}
              >
                {dynamic_description}
              </SweetAlert>
            ) : null}
            <Col
              xl={6}
              className="mx-auto"
              style={{
                maxWidth: "480px",
                backgroundColor: "white",
                // backgroundImage: `url(${bgImage})`,
                // backgroundSize: "cover",
              }}
            >
              {/* <img
                src={bgImage}
                alt=""
                style={{
                  position: "absolute",
                  objectFit: "contain",
                  maxWidth: "480px",
                }}
              /> */}
              <div
                className="auth-full-page-content"
                style={{
                  minHeight: "100vh",
                  paddingTop: "122px",
                  backgroundColor: "#F5F5F5",
                  paddingBottom: "92px",
                }}
              >
                <div className="w-100">
                  <div className="d-flex flex-column h-100">
                    <Row
                      className="m-0 w-100"
                      style={{
                        height: "56px",
                        backgroundColor: "#009FE2",
                        position: "fixed",
                        top: 0,
                        zIndex: 1030,
                        maxWidth: "480px",
                      }}
                    >
                      <Col xs={2} className="ps-0">
                        {/* <Link to="/categories"> */}
                        <Button
                          className="h-100 m-0"
                          onClick={() => {
                            history.goBack()
                          }}
                        >
                          <i className="bx bx-arrow-back align-middle font-size-20 text-white" />
                        </Button>
                        {/* </Link> */}
                      </Col>
                      <Col xs={8} className="align-self-center">
                        <p className="h-100 text-white font-size-15 my-auto text-center">
                          {props.t("Card Selection")}
                        </p>
                      </Col>
                      <Col xs={2} className="pe-0">
                        {/* <Link to="#">
                          <Button className="h-100 m-0">
                            <i className="bx bx-basket align-middle font-size-28 text-white" />
                          </Button>
                        </Link> */}
                      </Col>
                    </Row>
                    <Row
                      className="m-0 w-100"
                      style={{
                        height: "66px",
                        position: "fixed",
                        top: 56,
                        zIndex: 1020,
                        maxWidth: "480px",
                      }}
                    >
                      <Col xs={4} className="p-0">
                        <div
                          className="w-100 h-100 m-0"
                          style={{
                            borderRadius: 0,
                            borderBottom: "5px",
                            borderBottomColor: "#009FE2",
                            borderBottomStyle: "solid",
                            backgroundColor: "white",
                            textTransform: "none",
                          }}
                        >
                          <Row>
                            <Col xs="auto" className="mx-auto">
                              <img
                                src={iconCurrent}
                                className="avatar-sm mt-2 mb-1"
                                alt=""
                                style={{ maxWidth: "20px", maxHeight: "20px" }}
                              />
                            </Col>
                          </Row>
                          <Row>
                            <Col xs="auto" className="mx-auto">
                              <span
                                className="font-size-12 text-primary"
                                // style={{ color: "#4A4A4A" }}
                              >
                                {props.t("Card Selection")}
                              </span>
                            </Col>
                          </Row>
                        </div>
                      </Col>
                      <Col xs={4} className="p-0">
                        <div
                          className="w-100 h-100 m-0"
                          style={{
                            borderRadius: 0,
                            borderBottom: "5px",
                            borderBottomColor: "#B1B1B1",
                            borderBottomStyle: "solid",
                            backgroundColor: "white",
                            textTransform: "none",
                          }}
                        >
                          <Row>
                            <Col xs="auto" className="mx-auto">
                              <img
                                src={iconIncomplete}
                                className="avatar-sm mt-2 mb-1"
                                alt=""
                                style={{ maxWidth: "20px", maxHeight: "20px" }}
                              />
                            </Col>
                          </Row>
                          <Row>
                            <Col xs="auto" className="mx-auto">
                              <span
                                className="font-size-12"
                                style={{ color: "#B1B1B1" }}
                              >
                                {props.t("Customisation")}
                              </span>
                            </Col>
                          </Row>
                        </div>
                      </Col>
                      <Col xs={4} className="p-0">
                        <div
                          className="w-100 h-100 m-0"
                          style={{
                            borderRadius: 0,
                            borderBottom: "5px",
                            borderBottomColor: "#B1B1B1",
                            borderBottomStyle: "solid",
                            backgroundColor: "white",
                            textTransform: "none",
                          }}
                        >
                          <Row>
                            <Col xs="auto" className="mx-auto">
                              <img
                                src={iconIncomplete}
                                className="avatar-sm mt-2 mb-1"
                                alt=""
                                style={{ maxWidth: "20px", maxHeight: "20px" }}
                              />
                            </Col>
                          </Row>
                          <Row>
                            <Col xs="auto" className="mx-auto">
                              <span
                                className="font-size-12"
                                style={{ color: "#B1B1B1" }}
                              >
                                {props.t("Order")}
                              </span>
                            </Col>
                          </Row>
                        </div>
                      </Col>
                    </Row>
                    {giftData && giftcardId != "0" && (
                      <Row>
                        <Col>
                          <Card
                            className="mb-0 p-3"
                            style={{
                              borderRadius: "0px",
                              // width: "160px",
                              // height: "196px",
                              backgroundColor: "white",
                            }}
                          >
                            <CardImg
                              top
                              className="img-fluid"
                              src={giftData.image_thumbnail}
                              alt=""
                              style={{
                                aspectRatio: "3/2",
                                objectFit: "cover",
                                borderRadius: "14px",
                              }}
                            />
                          </Card>
                        </Col>
                      </Row>
                    )}
                    {giftCategoryData &&
                      giftCategoryData.map((data, index) => (
                        <Row key={`data-${index}`}>
                          <Col>
                            <Card
                              className="mt-3"
                              style={{
                                borderRadius: "0px",
                                // width: "160px",
                                // height: "196px",
                                backgroundColor: "white",
                              }}
                            >
                              <CardTitle className="px-3 font-size-15 text-black pt-3 mb-0">
                                {data.category_name}
                              </CardTitle>
                              <Row className="px-3">
                                {data.giftcards &&
                                  data.giftcards.map((cardData, index) => (
                                    <Col
                                      className="p-3"
                                      xs="6"
                                      key={`data-${index}`}
                                    >
                                      <Card
                                        className="mb-0 shadow-none"
                                        style={{
                                          borderRadius: "0px",
                                          // width: "160px",
                                          // height: "196px",
                                          // backgroundImage: `url("${cardData.image}")`,
                                          backgroundColor: "transparent",
                                          // backgroundSize: "cover",
                                        }}
                                        onClick={() => {
                                          setGiftcardId(cardData.id)
                                        }}
                                      >
                                        <CardImg
                                          top
                                          className="img-fluid mb-2 mx-auto"
                                          src={cardData.image_thumbnail}
                                          alt=""
                                          style={{
                                            width: "100%",
                                            borderRadius: "14px",
                                            aspectRatio: "3/2",
                                            objectFit: "cover",
                                            border:
                                              giftcardId == cardData.id
                                                ? "2px solid #009FE2"
                                                : "none",
                                          }}
                                        />
                                        {cardData.is_editable == "Yes" && (
                                          <img
                                            // top
                                            // className="mx-auto"
                                            src={iconEditable}
                                            alt=""
                                            style={{
                                              position: "absolute",
                                              top: 8,
                                              right: 8,
                                              // height: "92px",
                                            }}
                                          />
                                        )}
                                        <CardTitle
                                          className="mx-auto text-dark"
                                          style={{
                                            fontWeight: 400,
                                            width: "160px",
                                          }}
                                        >
                                          {
                                            multiLanguageHandler(
                                              cardData.multiple_languages
                                            ).name
                                          }
                                        </CardTitle>
                                      </Card>
                                    </Col>
                                  ))}
                              </Row>
                            </Card>
                          </Col>
                        </Row>
                      ))}
                    <Row
                      className="m-0 w-100"
                      style={{
                        height: "76px",
                        backgroundColor: "#ffffff",
                        position: "fixed",
                        bottom: 0,
                        zIndex: 1030,
                        maxWidth: "480px",
                        boxShadow: "0 -0.75rem 1.5rem rgba(18, 38, 63, 0.03)",
                      }}
                    >
                      <Col className="h-100 p-0">
                        <Card body className="mb-0 p-3">
                          <Row>
                            <Col>
                              <button
                                className="btn btn-danger waves-effect waves-light font-size-18 w-100"
                                // style={{ height: "42px" }}
                                onClick={updateGiftCardId}
                              >
                                {props.t("Next Step")}
                              </button>
                            </Col>
                            <Col>
                              <button
                                className="btn btn-danger waves-effect waves-light font-size-18 w-100"
                                // style={{ height: "42px" }}
                                onClick={() => {
                                  history.push("/checkout-confirmation")
                                }}
                              >
                                {props.t("Skip")}
                              </button>
                            </Col>
                          </Row>
                        </Card>
                      </Col>
                    </Row>
                  </div>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  )
}

export default withTranslation()(CheckoutConfirmation)

CheckoutConfirmation.propTypes = {
  t: PropTypes.any,
}
